<template>
  <div>
    <b-overlay :show="isFormBusy" rounded="sm" spinner-variant="primary" opacity="0.8">
      <b-form ref="recordForm" id="CnRRecordForm" style="max-width: 1140px">
        <div class="row">
          <div class="col pr-0">
            <label class="text-muted d-block mb-1"><small>Bezeichnung</small></label>
            <b-input
              v-model="record.Description"
              @keyup="onFormFieldKeyUp"
              required
              maxlength="50"
              :autofocus="$route.params.rid == 'create'"
              ref="firstField"
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
            />
            <label class="text-muted d-block mt-1 mb-1"><small>Datum</small></label>
            <b-input
              v-model="record.Datum"
              type="date"
              min="2000-01-01"
              max="2099-12-31"
              required
              @update="onFormFieldKeyUp"
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
            />
            <label class="text-muted d-block mt-1 mb-1"><small>Chance oder Risiko</small></label>
            <b-form-select
              v-model="record.Type"
              class="mb-3"
              @change="onFormFieldKeyUp"
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
              :style="{ 'background-color': record.Type == 'C' ? '#DEF7E1' : '#FDD8DB' }"
            >
              <template #first>
                <b-form-select-option style="background-color:white" :value="null" disabled>
                  -- Art wählen --
                </b-form-select-option>
              </template>
              <b-form-select-option style="background-color:white" value="C">Chance</b-form-select-option>
              <b-form-select-option style="background-color:white" value="R">Risiko</b-form-select-option>
            </b-form-select>
          </div>
          <div class="col" style="max-width: 535px">
            <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
            <b-form-textarea
              id="textarea"
              placeholder="Langtext..."
              rows="7"
              max-rows="7"
              v-model="record.LongDescription"
              @keyup="onFormFieldKeyUp"
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
            ></b-form-textarea>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mt-3">Bewertung</h5>
            <hr class="mt-0" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <!--<label class="text-muted d-block mb-1"><small>Bewertung</small></label> -->
            <!--
            <b-input-group append="€">
              <b-input
                class="text-right"
                v-model="record.Amount"
                placeholder="Betrag"
                @keyup="onFormFieldKeyUp($event)"
                @update="recalcPrognose('Amount')"
                type="number"
                step="0.01"
                min="0"
                :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                required
                lazy
                @focus="selectText"
              />
            </b-input-group>-->
            <AkCurrencyField
              v-model="record.Amount"
              label="Prognose"
              label-class="text-small"
              min="0"
              input-class="text-right"
              input-ref="myfield"
              @update="recalcPrognose('Amount')"
              @keyup="onFormFieldKeyUp($event)"
              @focus="selectText"
              append
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
            />
          </div>
          <div class="col">
            <label class="text-muted d-block mb-1"><small>Prognoserelevanz</small></label>
            <b-input-group append="%" :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)">
              <b-input
                class="text-right"
                v-model="AmountPercent"
                placeholder="Prozent"
                @keyup="onFormFieldKeyUp($event)"
                @update="recalcPrognose('Percent')"
                type="number"
                step="0.1"
                min="0"
                max="100"
                :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                lazy
                @focus="selectText"
                :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
              />
            </b-input-group>
          </div>
          <div class="col">
            <!--
            <label class="text-muted d-block mb-1"><small>Bewertung Prognoserelevanz</small></label>
            <b-input-group append="€">
              <b-input
                class="text-right"
                v-model="record.AmountProg"
                placeholder="Betrag"
                @keyup="onFormFieldKeyUp($event)"
                @update="recalcPrognose('Prognose')"
                type="number"
                step="0.01"
                min="0"
                :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                lazy
                :max="record.Amount"
                :required="record.Amount != null && record.Amount != ''"
                @focus="selectText"
              />
            </b-input-group>
            -->
            <AkCurrencyField
              v-model="record.AmountProg"
              label="Bewertung Prognoserelevanz"
              label-class="text-small"
              min="0"
              input-class="text-right"
              input-ref="myfield"
              @update="recalcPrognose('Prognose')"
              @keyup="onFormFieldKeyUp($event)"
              @focus="selectText"
              append
              placeholder="Betrag"
              :required="record.Amount != null && record.Amount != ''"
              :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
            />
          </div>
        </div>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import RisksService from '@/service/RisksService';
import AkCurrencyField from '@/components/AkCurrencyField';

export default {
  components: {
    AkCurrencyField
  },
  async activated() {
    this.isFormBusy = true;

    this.$forceUpdate();
    this.$eventBus.$on('form:risks:save', this.saveRecordAndReturn);
    this.$eventBus.$on('CnRVE:changed', this.onVeChanged);
    AppState.isLoading = false;
    this.AmountPercent = null;
    AppState.currentCnRIsDirty = false;
    if (!AppState.currentCnRVE && !this.$route.path.startsWith('/risks/project')) {
      // AppState.currentCnRVE = await RisksService.getVESummary(this.$route.params.id);
    }

    if (this.$route.params.rid && this.$route.params.rid != 'create') {
      /* ------------------
          L O A D  RECORD
      --------------------*/
      AppState.currentCnR = null;

      this.record = await RisksService.getCnRById(this.$route.params.rid);

      AppState.currentCnR = this.record;

      this.recalcPrognose('Amount');
    } else {
      /* ------------------
          N E W  RECORD
      --------------------*/
      document.title = 'Risiko erfassen';

      this.AmountPercent = 0;
      this.record = {
        Amount: 0,
        AmountProg: 0,
        Type: 'R',
        RefDbId: isNaN(parseInt(this.$route.params.id)) ? null : parseInt(this.$route.params.id)
      };
      this.$nextTick(() => {
        this.$refs.firstField.focus();
      });
    }
    this.isFormBusy = false;
  },
  async deactivated() {
    this.$eventBus.$off('form:risks:save', this.saveRecordAndReturn);
    this.$eventBus.$off('CnRVE:changed', this.onVeChanged);
  },
  data() {
    return {
      isFormBusy: true,
      AmountPercent: null,
      record: {
        AmountProg: null
      }
    };
  },
  methods: {
    onFormFieldKeyUp() {
      AppState.currentCnRIsDirty = true;
    },
    async saveRecordAndReturn() {
      var form = document.querySelector('#CnRRecordForm');
      var isValid = true;
      for (const element of form.elements) {
        if (element.classList.contains('is-invalid')) isValid = false;
      }
      if (!isValid) return;

      this.record.RefDbId = AppState.currentCnRVE ? AppState.currentCnRVE.VeDbId : null;
      if (this.record.RefDbId == null && this.$route.name == 'Chancen & Risiken ohne VE') {
        return this.$nextTick(() => this.$eventBus.$emit('CnR:showVEValidation'));
      }
      if (!this.$refs.recordForm.checkValidity()) {
        //evt.preventDefault();
        return this.$refs.recordForm.reportValidity();
      } else {
        if (this.$route.params.rid && this.$route.params.rid != 'create') {
          this.isFormBusy = true;
          await RisksService.update(this.record);
          this.isFormBusy = false;
        } else {
          this.isFormBusy = true;
          await RisksService.create(this.record);
          this.isFormBusy = false;
        }

        this.$router.push(this.$route.path.substring(0, this.$route.path.lastIndexOf('/'))).catch(() => {});
        this.$showSuccess(this, 'Risiko speichern', 'Risiko erfolgreich gespeichert.');
        this.$eventBus.$emit('CnR:deleted'); // deleted means created here
      }
    },
    recalcPrognose(whatChanged) {
      switch (whatChanged) {
        case 'Amount':
          if (this.record.Amount && this.record.Amount != '' && this.AmountPercent && this.AmountPercent != '') {
            if (parseFloat(this.record.Amount) < 0) {
              if (!this.$refs.recordForm.checkValidity()) {
                return this.$refs.recordForm.reportValidity();
              }
            }
            this.record.AmountProg = (parseFloat(this.record.Amount) * parseFloat(this.AmountPercent)) / 100;
          } else if (
            this.record.Amount &&
            this.record.Amount != '' &&
            this.record.Amount &&
            this.record.AmountProg != ''
          ) {
            this.AmountPercent = this.$utils.numberWithMaxFrictions(
              (this.record.AmountProg / this.record.Amount) * 100,
              1
            );

            /*
            if (this.record.AmountPercent != '') {
              console.log('zzz calcing prog ', this.AmountPercent);
              this.record.AmountProg = (parseFloat(this.record.Amount) * parseFloat(this.AmountPercent)) / 100;
            } else {
              console.log('zzz calcing % ', parseFloat(this.record.Amount), parseFloat(this.record.AmountProg));
              this.AmountPercent = this.$utils.numberWithMaxFrictions(
                (this.record.AmountProg / this.record.Amount) * 100,
                1
              );
            }*/
          }

          break;
        case 'Percent':
          if (parseFloat(this.AmountPercent) < 0) {
            if (!this.$refs.recordForm.checkValidity()) {
              return this.$refs.recordForm.reportValidity();
            }
          }
          this.record.AmountProg = (parseFloat(this.record.Amount) * parseFloat(this.AmountPercent)) / 100;
          //this.$forceUpdate();
          break;
        case 'Prognose':
          if (parseFloat(this.record.AmountProg) < 0) {
            if (!this.$refs.recordForm.checkValidity()) {
              return this.$refs.recordForm.reportValidity();
            }
          }
          this.AmountPercent = this.$utils.numberWithMaxFrictions(
            (this.record.AmountProg / this.record.Amount) * 100,
            1
          );
          break;
        default:
          break;
      }
    },
    onVeChanged() {
      RisksService.getVESummary;
      this.$nextTick(() => {
        this.$refs.firstField.focus();
      });
    },
    selectText(param) {
      if (param && param.target) param.target.select();
    }
  }
};
</script>

<style></style>
